module.exports = __webpack_public_path__ + "img/22238800_s.bf207341.jpg";